const BASE = '/api';

const req = async (method, path, body, token) => {
  const opts = {
    method,
    headers: { 'Content-Type': 'application/json' },
  };
  if (token) opts.headers['Authorization'] = `Bearer ${token}`;
  if (body) opts.body = JSON.stringify(body);
  const res = await fetch(`${BASE}/${path}`, opts);
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Error desconocido');
  return data;
};

// Auth
export const login = (username, password) =>
  req('POST', 'auth/login', { username, password });
export const getMe = (token) => req('GET', 'auth/me', null, token);
export const changePasswordAdmin = (body, token) =>
  req('POST', 'auth/change-password', body, token);

// Superadmin — clientes
export const getClients = (token) => req('GET', 'admin/clients', null, token);
export const createClient = (body, token) => req('POST', 'admin/clients', body, token);
export const patchClient = (id, body, token) => req('PATCH', `admin/clients/${id}`, body, token);
export const deleteClient = (id, token) => req('DELETE', `admin/clients/${id}`, null, token);
export const changeClientPassword = (id, body, token) =>
  req('POST', `admin/clients/${id}/change-password`, body, token);

// Superadmin — plantilla
export const getTemplate = (token) => req('GET', 'admin/template', null, token);
export const putTemplateConfig = (body, token) => req('PUT', 'admin/template/config', body, token);
export const addTemplateProduct = (body, token) => req('POST', 'admin/template/productos', body, token);
export const editTemplateProduct = (id, body, token) => req('PUT', `admin/template/productos/${id}`, body, token);
export const deleteTemplateProduct = (id, token) => req('DELETE', `admin/template/productos/${id}`, null, token);

// Cliente — su tienda
export const getMyStore = (token) => req('GET', 'client/store', null, token);
export const getMyStoreConfig = (token) => req('GET', 'client/store/config', null, token);
export const putMyStoreConfig = (body, token) => req('PUT', 'client/store/config', body, token);
export const addProduct = (body, token) => req('POST', 'client/store/productos', body, token);
export const editProduct = (id, body, token) => req('PUT', `client/store/productos/${id}`, body, token);
export const deleteProduct = (id, token) => req('DELETE', `client/store/productos/${id}`, null, token);

// Tienda pública (sin auth)
export const getPublicStore = (clientId) => req('GET', `store/${clientId}`);

// MercadoPago
export const createPreference = (clientId, body) =>
  req('POST', `mp/create-preference/${clientId}`, body);
